<template>
<div>
  <div class="pt-60 pb-20 fs-26 bold">{{info.moduleTitle}}</div>
  <div class="carousel-mol carousel-1">
    <el-carousel height="480px" indicator-position="outside" arrow="never" :autoplay="autoPlay" :direction="switchEffect">
      <el-carousel-item v-for="(o, i) in dataList" :key="i">
        <div class="a-pic-box" @click="toConnection(o.connection)">
          <img :src="o.pictureUrl" v-if="o.pictureUrl"/>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    let extra = this.info.extra || {}
    let dataList = extra.pictureInfoList || []
    let switchEffect = extra.switchEffect == 1 ? 'vertical' : 'horizontal'
    let autoPlay = extra.autoPlay === 0
    return {
      dataList,
      switchEffect,
      autoPlay
    }
  },
  mounted () {
  },
  methods: {
    toConnection (url) {
      if (!url) {
        return ''
      }
      window.open(url)
    }
  }
}
</script>
